import { createSelector } from '@reduxjs/toolkit';

import type {
  BankAccountPaymentMethod,
  CardPaymentMethod,
} from 'models/paymentMethod';
import type { User } from 'models/user';
import type { RootState } from 'reducers/types';

export const getEmail = (state: RootState) => {
  const {
    entities: {
      user: { email = null },
    },
  } = state;

  return email;
};

export const getUser = (state: RootState): User => {
  const {
    entities: { user },
  } = state;

  return user;
};

export const getIsSocialAccount = (state: RootState) => {
  const { authProvider } = getUser(state);

  return authProvider != null && authProvider !== 'password';
};

export const getPaymentMethods = (state: RootState) => {
  const { paymentMethods } = getUser(state);

  return paymentMethods;
};

export const getCreditCards = createSelector(
  [getPaymentMethods],
  paymentMethods => {
    return paymentMethods
      ? (paymentMethods?.filter(
          pm => pm.type === 'card',
        ) as CardPaymentMethod[])
      : undefined;
  },
);

export const getBankAccounts = createSelector(
  [getPaymentMethods],
  paymentMethods => {
    return paymentMethods
      ? (paymentMethods.filter(
          pm => pm.type === 'bank_account',
        ) as BankAccountPaymentMethod[])
      : undefined;
  },
);
